import { isTag } from "domhandler";

import { HtmlToReactProcessor } from "./processor";

export type MarksOptions = Record<string | "*", "include" | "exclude">;

/**
 * Marks allow us to annotate content in our RCE that requires special treatment
 * during render time. Currenly, we use it to denote areas of "enhanced TEKS
 * clarification" inside of an Objective that gets rendered in Go TCMPC.
 */
const ProcessMarks = (
  marks: MarksOptions | undefined,
): HtmlToReactProcessor => {
  const markPattern = /\bexamspark-(mark-)?(?<mark>\w+)\b/;
  const excludeByDefault = marks?.["*"] === "exclude";

  return (node) => {
    if (!isTag(node)) return;
    const match = node.attribs?.class?.match(markPattern);
    if (!match?.groups?.mark) return;

    const includeOrExclude = marks?.[match.groups?.mark];

    if (includeOrExclude === "exclude") return null;

    if (includeOrExclude === "include" || !excludeByDefault) {
      return;
    }

    return null;
  };
};

export default ProcessMarks;
